import { render, staticRenderFns } from "./papar_projek.vue?vue&type=template&id=745fe451"
import script from "./papar_projek.vue?vue&type=script&lang=js"
export * from "./papar_projek.vue?vue&type=script&lang=js"
import style0 from "./papar_projek.vue?vue&type=style&index=0&id=745fe451&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports